import { t, tf } from "./i18n.js";
import { erzeugeAufnahmeEingabe } from "./aufnahme-eingabe.js";
// ==========================================
// ROUND THE WORLD LOGIK (21 Runden, Punkte sammeln & Speichern)
// ==========================================

window.rtwPlayer = null;
let rtwHistoryStack = [];
let rtwTargetMode = "double"; // 'single', 'double', 'triple'
// FIX: Ohne dieses Flag konnten zwei schnelle Eingaben auf dem letzten Ziel
// submitRtwScore() doppelt ausloesen -> doppelter Insert in stats_rtw.
window.isRtwGameOver = false;

const rtwTargets = [
  20, 1, 18, 4, 13, 6, 10, 15, 2, 17, 3, 19, 7, 16, 8, 11, 14, 9, 12, 5, 25,
];

function startRtwGame() {
  const nameInput =
    document.getElementById("rtw-player-input").value.trim() || t("js.app.009");
  const modeSelect = document.getElementById("rtw-target-mode");
  rtwTargetMode = modeSelect ? modeSelect.value : "double";

  rtwPlayer = {
    name: nameInput,
    targetIndex: 0,
    dartsThrown: 0,
    pointsTable: [],
    totalPoints: 0,
  };
  rtwHistoryStack = [];
  isRtwGameOver = false;

  document.getElementById("btn-undo-rtw").style.display = "none";
  document.getElementById("rtw-setup-screen").style.display = "none";
  document.getElementById("game-rtw-screen").style.display = "block";

  // ERST sichtbar, DANN bauen - createDartboard misst beim Zeichnen.
  rtwEingabe.baue();
  rtwEingabe.leere();
  rtwEingabe.aktualisiereSichtbarkeit();

  updateRtwUI();

  // Spielwache scharf (29.08.2026).
  spielwacheSpielGestartet("rtw", sichereRtwStand);
}

// ── Spielwache: sichern & wiederherstellen (29.08.2026) ─────────────────
function sichereRtwStand() {
  return { player: rtwPlayer, mode: rtwTargetMode };
}

function stelleRtwWieder(stand) {
  openRtwSetup();
  rtwPlayer = { ...stand.player };
  rtwTargetMode = stand.mode || "double";
  rtwHistoryStack = [];
  isRtwGameOver = false;

  const nameFeld = document.getElementById("rtw-player-input");
  if (nameFeld) nameFeld.value = rtwPlayer.name;
  const modusWahl = document.getElementById("rtw-target-mode");
  if (modusWahl) modusWahl.value = rtwTargetMode;
  const undoBtn = document.getElementById("btn-undo-rtw");
  if (undoBtn) undoBtn.style.display = "none";

  document.getElementById("rtw-setup-screen").style.display = "none";
  document.getElementById("game-rtw-screen").style.display = "block";
  rtwEingabe.baue();
  rtwEingabe.leere();
  rtwEingabe.aktualisiereSichtbarkeit();
  updateRtwUI();
  spielwacheSpielGestartet("rtw", sichereRtwStand);
}

spielwacheRegistriereFortsetzen("rtw", "Round the World", stelleRtwWieder);

function cancelRtwGame() {
  cancelCurrentGame("game-rtw-screen");
}

function updateRtwUI() {
  const targetVal = rtwTargets[rtwPlayer.targetIndex];

  document.getElementById("rtw-turn-indicator").innerText =
    tf("js.rtw.002", { p1: rtwPlayer.name });
  document.getElementById("rtw-points-count").innerText =
    `${rtwPlayer.totalPoints}`;

  let targetDisplay = targetVal;

  if (targetVal === 25) {
    targetDisplay =
      rtwTargetMode === "double" || rtwTargetMode === "triple"
        ? "BULLSEYE"
        : rtwTargetMode === "all"
          ? "BULL"
          : "SINGLE BULL";
  } else {
    if (rtwTargetMode === "double") targetDisplay = "D" + targetVal;
    else if (rtwTargetMode === "triple") targetDisplay = "T" + targetVal;
    else if (rtwTargetMode === "all") targetDisplay = "" + targetVal;
  }

  document.getElementById("rtw-target-display").innerText = targetDisplay;
  // Zielfeld auf der echten Scheibe hervorheben (frueher: stilisiertes Board).
  rtwEingabe.aktualisiereZiel();
  rtwEingabe.zeichne();

  updateRtwHistoryUI();
  // Nach jeder Standaenderung spiegeln (spielwache.js, 29.08.2026).
  if (typeof spielwacheTick === "function") spielwacheTick();
}

function updateRtwHistoryUI() {
  if (!rtwPlayer) return;
  renderUniversalMiniGameHistory(
    "side-history-list-rtw",
    "history-rtw-name",
    rtwPlayer.name,
    rtwPlayer.pointsTable,
    "rtw",
  );
}

// NEU: Supabase Speicherfunktion (läuft leise im Hintergrund)
async function saveRtwStatsBackground() {
  try {
    const payload = {
      name: rtwPlayer.name,
      total_points: rtwPlayer.totalPoints,
      mode: rtwTargetMode,
      details: rtwPlayer.pointsTable, // Speichert das Array als JSONB
    };

    // Wenn der User eingeloggt ist (aus app.js), verknüpfen wir die user_id
    if (typeof currentUser !== "undefined" && currentUser) {
      payload.user_id = currentUser.id;
    }

    const { error } = await _supabase.from("stats_rtw").insert([payload]);

    if (error) {
      console.error(t("js.rtw.001"), error.message);
    } else {
      console.log(
        "✅ RTW-Stats erfolgreich im Hintergrund in Supabase gespeichert!",
      );
    }
  } catch (err) {
    console.error(t("js.g121.002"), err);
  }
}

/** @param {number} hits      Treffer dieser Aufnahme
 *  @param {number} [darts]   tatsaechlich geworfene Darts. Fehlt sie (Test,
 *                            alter Aufrufer), bleibt es bei drei - so wie
 *                            frueher pauschal gezaehlt wurde. */
function submitRtwScore(hits, darts) {
  if (isRtwGameOver || !rtwPlayer) return;

  rtwHistoryStack.push({
    targetIndex: rtwPlayer.targetIndex,
    dartsThrown: rtwPlayer.dartsThrown,
    totalPoints: rtwPlayer.totalPoints,
    tableLength: rtwPlayer.pointsTable.length,
  });
  document.getElementById("btn-undo-rtw").style.display = "block";

  const currentTarget = rtwTargets[rtwPlayer.targetIndex];
  rtwPlayer.pointsTable.push({
    target: currentTarget,
    hits: hits,
  });
  rtwPlayer.totalPoints += hits;

  rtwPlayer.dartsThrown += Number.isFinite(darts) && darts > 0 ? darts : 3;
  rtwPlayer.targetIndex += 1;

  if (rtwPlayer.targetIndex >= rtwTargets.length) {
    isRtwGameOver = true;
    rtwPlayer.targetIndex = rtwTargets.length - 1;
    updateRtwUI();

    // Sobald das letzte Feld bespielt wurde, feuern wir den Upload in den Hintergrund ab!
    saveRtwStatsBackground();
    spielwacheSpielBeendet();
    // Gemeinsamer Endbildschirm statt Toast + goHome (Produkttest
    // 29.08.2026).
    zeigeEndbildschirm({
      screenId: "game-rtw-screen",
      titel: t("js.ende.geschafft"),
      untertitel: t("js.rtw.003"),
      zeilen: [],
      kennzahlen: [
        { label: t("aufnahme.treffer"), wert: rtwPlayer.totalPoints },
        { label: "Darts", wert: rtwPlayer.dartsThrown },
      ],
      revanche: () => startRtwGame(),
      setup: () => openRtwSetup(),
    });
    return;
  }

  updateRtwUI();
}

function undoRtwTurn() {
  if (rtwHistoryStack.length === 0 || !rtwPlayer) return;
  const lastState = rtwHistoryStack.pop();

  rtwPlayer.targetIndex = lastState.targetIndex;
  rtwPlayer.dartsThrown = lastState.dartsThrown;
  rtwPlayer.totalPoints = lastState.totalPoints;

  rtwPlayer.pointsTable = rtwPlayer.pointsTable.slice(0, lastState.tableLength);

  if (rtwHistoryStack.length === 0)
    document.getElementById("btn-undo-rtw").style.display = "none";

  // Wie bei Bob's: die Kacheln gehoeren zum zurueckgenommenen Zug.
  rtwEingabe.leere();
  updateRtwUI();
}

// ── Auto-Score-Adapter (autoscore.js, 13.08.2026) ──────────────────────────
//
// Round the World ist aufnahme-basiert: Drei Darts aufs aktuelle Ziel im
// gewaehlten Ringmodus, gezogen, gewertet. Der Treffer-Massstab folgt
// exakt der Zielanzeige (updateRtwUI): single = Single des Ziels bzw.
// SINGLE BULL (25); double/triple = D/T des Ziels bzw. BULLSEYE (50);
// all = jeder Ring des Ziels bzw. beide Bulls. Jeder erkannte Dart wird
// im Ziel-Board markiert; der Zielwechsel zeichnet es neu.
function rtwTrifft(dart) {
  if (!rtwPlayer || !dart) return false;
  const ziel = rtwTargets[rtwPlayer.targetIndex];
  const base = Number(dart.base ?? 0);
  // multiplier ZUERST: Handdarts (board-input.js, aufnahme-eingabe.js) fuehren
  // multiplier, der Tracker-Payload mult. Nur eines zu lesen hat frueher
  // Treffer verschluckt.
  const mult = Number(dart.multiplier ?? dart.mult ?? 1);
  if (ziel === 25) {
    if (rtwTargetMode === "single") return base === 25;
    if (rtwTargetMode === "all") return base === 25 || base === 50;
    return base === 50; // double/triple: Bullseye
  }
  if (base !== ziel) return false;
  if (rtwTargetMode === "double") return mult === 2;
  if (rtwTargetMode === "triple") return mult === 3;
  if (rtwTargetMode === "single") return mult === 1;
  return true; // all
}

/** Die Felder, die beim aktuellen Ziel zaehlen - als Liste fuer das Board.
 *
 *  Sie wird aus DERSELBEN Fallunterscheidung wie rtwTrifft() gespeist. Ein
 *  Feld, das blinkt aber nicht zaehlt (oder umgekehrt), waere schlimmer als
 *  gar keine Hervorhebung. */
function rtwZielFelder() {
  if (!rtwPlayer) return [];
  const ziel = rtwTargets[rtwPlayer.targetIndex];
  if (ziel === 25) {
    if (rtwTargetMode === "single") return [{ base: 25 }];
    if (rtwTargetMode === "all") return [{ base: 25 }, { base: 50 }];
    return [{ base: 50 }];
  }
  if (rtwTargetMode === "double") return [{ base: ziel, mult: 2 }];
  if (rtwTargetMode === "triple") return [{ base: ziel, mult: 3 }];
  if (rtwTargetMode === "single") return [{ base: ziel, mult: 1 }];
  return [{ base: ziel }]; // all
}

// ---------------------------------------------------------------------------
// EINGABE (14.08.2026): drei Darts statt "wie oft getroffen?"
// Begruendung wie bei Bob's 27 - der Tracker liefert einzelne Darts, und die
// Trefferzahl leitet RTW selbst ab. submitRtwScore() bleibt unveraendert.
// ---------------------------------------------------------------------------
const rtwEingabe = erzeugeAufnahmeEingabe({
  modus: "rtw",
  ziel: () => document.getElementById("aufnahme-rtw"),
  aktiv: () =>
    document.getElementById("game-rtw-screen")?.style.display !== "none" &&
    !!rtwPlayer &&
    !isRtwGameOver,
  zielFelder: rtwZielFelder,
  bilanz: (darts) => ({
    name: t("aufnahme.treffer", "Treffer"),
    wert: darts.filter(rtwTrifft).length,
  }),
  onAufnahme: (wuerfe) => {
    if (isRtwGameOver || !rtwPlayer) return false;
    submitRtwScore(wuerfe.filter(rtwTrifft).length, wuerfe.length);
    return true;
  },
});

// ---------------------------------------------------------------
// Bruecke zu window: Inline-Handler im HTML und andere Module greifen
// weiterhin global auf diese Funktionen zu. Automatisch erzeugt beim
// Umstieg auf Vite - Modul-Scope ersetzt sonst die alten Globals.
// ---------------------------------------------------------------
Object.assign(window, {
  startRtwGame,
  cancelRtwGame,
  submitRtwScore,
  undoRtwTurn,
  rtwEingabe,
});
